import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { BookingService } from '@app/listing/services/booking.service';
import { NotificationService, ErrorHelperService, ValueService } from '@app/services';


@Component({
    selector: "text-arrival-instruction-button",
    templateUrl: "./text-arrival-instruction-button.component.html",
    styleUrls: ["./text-arrival-instruction-button.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class TextArrivalInstructionButtonComponent implements OnInit {
  private readonly _componentName = 'TextArrivalInstructionButtonComponent';
  private _buttonText : string = 'Text Arrival Instructions Audio';  
  private _bookingId: string;

  constructor(private bookingService: BookingService, private notify: NotificationService, private valuehelper: ValueService) {}

  ngOnInit() {}

  public get bookingId(): string {
    return this._bookingId;
  }

  @Input()
  public set bookingId(v: string) {
    this._bookingId = v;
  }

  public get buttonText() : string {
    return this._buttonText;
  }

  @Input()
  public set buttonText(v : string) {
    this._buttonText = v;
  }
  

  public onTextArrivalInstructions() {
    this.bookingService.sendArrivalInstructions(this.bookingId).subscribe(
      data => {
        this.notify.success('A text message successfully was successfully sent.');
      },
      resp => {
        console.error(resp);

        let msg = this.valuehelper.getSafeValue(resp, 'error.message');

        if (!msg) {
          msg = 'An error occurred while sending text message.';
        }

        this.notify.error(msg, 'Text Arrival Instructions Error');
      }
    );
  }
}
